module.exports = __webpack_public_path__ + "static/Advantage03@3x.d3d8c152.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/events/new/Advantage03@3x.png
// module id = 691
// module chunks = 216210090109534